import { Flex, Text } from '@chakra-ui/react';
import { MessageCircle } from 'lucide-react';
import { pxToRem } from '@duke-hq/ui/constants/scalable';

export function EmptyTicketSelection() {
  return (
    <Flex h="full" w="full" align="flex-start" justify="center" pt="20vh">
      <Flex direction="column" align="center" gap={3} color="fg.muted">
        <MessageCircle size={pxToRem(48)} strokeWidth={1.5} />
        <Text fontSize="lg" fontWeight="medium">
          Nothing selected
        </Text>
        <Text fontSize="sm">Select from the list to view details</Text>
      </Flex>
    </Flex>
  );
}
